export function monthClosed(year,month,paid,now=new Date()){
 const parts=new Intl.DateTimeFormat('en',{timeZone:'America/Montevideo',year:'numeric',month:'2-digit'}).formatToParts(now);
 const current=Number(parts.find(p=>p.type==='year').value)*12+Number(parts.find(p=>p.type==='month').value);
 return paid===true && Number(year)*12+Number(month)<current;
}
export const paymentLabel=closed=>closed?'Mes cerrado · Liquidación paga':'Mes no cerrado · Estimado';
export const paymentLegend='Columnas atenuadas: mes no cerrado (estimado). Color pleno: mes finalizado con liquidación paga.';
